import { api } from "../../../../api/api";
import { IPaymentReminderConfigForm } from "../types/paymentReminderConfig.types";
import { ICampaignRuleTemplate } from "../../../../redux/marketCampaign/marketCampaign.types";

/**
 * Upsert (create or update) a payment reminder automation configuration.
 * Single API handles both create and update based on UUID presence.
 */
export const upsertPaymentReminderConfig = async (
  data: IPaymentReminderConfigForm,
) => {
  const res = await api.post(
    "/campaign/upsert-whatsapp-campaign-automation-configuration",
    data,
  );
  return res.data;
};

/**
 * Fetch the existing payment reminder configuration for a given outlet.
 * Returns the config object or null if none exists.
 */
export const fetchPaymentReminderConfig = async (
  company_outlet_uuid: string,
): Promise<IPaymentReminderConfigForm | null> => {
  try {
    const res = await api.get(
      "/campaign/get-whatsapp-campaign-automation-configurations",
      {
        params: { company_outlet_uuid },
      },
    );
    const data = res.data?.data;
    if (Array.isArray(data) && data.length > 0) {
      return data[0];
    }
    if (data && !Array.isArray(data)) {
      return data;
    }
    return null;
  } catch {
    return null;
  }
};

/**
 * Fetch ALL payment reminder configurations for a given outlet (returns array).
 */
export const fetchPaymentReminderConfigList = async (
  company_outlet_uuid: string,
): Promise<IPaymentReminderConfigForm[]> => {
  try {
    const res = await api.get(
      "/campaign/get-whatsapp-campaign-automation-configurations",
      {
        params: { company_outlet_uuid },
      },
    );
    const data = res.data?.data;
    if (Array.isArray(data)) {
      return data;
    }
    if (data) {
      return [data];
    }
    return [];
  } catch {
    return [];
  }
};


/**
 * Fetch campaign rule templates for the given outlet.
 * These templates define the dynamic event rule fields (event_type, duration, etc.)
 * with their options coming from the database.
 */
export const fetchCampaignRuleTemplates = async (
  company_outlet_uuid: string,
  template_key: string = "PAYMENT_REMINDER",
): Promise<ICampaignRuleTemplate[]> => {
  try {
    const res = await api.get("/campaign/get-campaign-rule-templates", {
      params: { company_outlet_uuid, template_key },
    });
    return res.data.data as ICampaignRuleTemplate[];
  } catch {
    return [];
  }
};
